module.exports = __webpack_public_path__ + "static/Cibee_Kamara-4bb2abf36ee81530f09bc1505a570a7c.png";